module.exports = __webpack_public_path__ + "static/media/estrella-logo.0644126c.avif";